export default __webpack_public_path__ + "static/media/7cap.0ac2f1f9.jpg";